// extracted by mini-css-extract-plugin
export default {"container":"specs-table__container___24E39","utqg-tooltip":"specs-table__utqg-tooltip___Mec8u","overview":"specs-table__overview___3d0hr"};